/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CustomerOrderDetInsertModel { 
    guid?: string;
    itemNumber?: string | null;
    description?: string | null;
    quantity?: number;
    uOfM?: string | null;
    unitPrice?: number;
    amount?: number;
    notes?: string | null;
    isPriceOverwrite?: boolean;
    userId?: number;
    statusId?: number;
}

